import { useFloating as a } from "../node_modules/.pnpm/@floating-ui_react@0.27.16_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { useState as m, useRef as p } from "react";
import { autoUpdate as u } from "../node_modules/.pnpm/@floating-ui_dom@1.7.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import { offset as c, flip as F, shift as T, arrow as d } from "../node_modules/.pnpm/@floating-ui_react-dom@2.1.6_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
const g = 20, O = 8, _ = ({
  placement: n = "bottom",
  tooltipOffset: r = g,
  shiftPadding: s = O
}) => {
  const [t, o] = m(!1), e = p(null), { refs: f, floatingStyles: i, context: l } = a({
    placement: n,
    open: t,
    onOpenChange: o,
    middleware: [c(r), F(), T({ padding: s }), d({ element: e })],
    whileElementsMounted: u
  });
  return {
    refs: f,
    floatingStyles: i,
    context: l,
    arrowRef: e,
    open: t,
    setOpen: o
  };
};
export {
  _ as useFloatingTooltip
};
